/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as OpsConsole7x2kRouteImport } from './routes/ops-console-7x2k'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as DesignOnboardingRouteImport } from './routes/design.onboarding'
import { Route as AuthedTransactionsRouteImport } from './routes/_authed/transactions'
import { Route as AuthedStripeRouteImport } from './routes/_authed/stripe'
import { Route as AuthedStakeholdersMergeRouteImport } from './routes/_authed/stakeholders-merge'
import { Route as AuthedStakeholdersCatRouteImport } from './routes/_authed/stakeholders-cat'
import { Route as AuthedStakeholdersRouteImport } from './routes/_authed/stakeholders'
import { Route as AuthedSourcesRouteImport } from './routes/_authed/sources'
import { Route as AuthedRulesRouteImport } from './routes/_authed/rules'
import { Route as AuthedReviewRouteImport } from './routes/_authed/review'
import { Route as AuthedRevenueRouteImport } from './routes/_authed/revenue'
import { Route as AuthedQueueRouteImport } from './routes/_authed/queue'
import { Route as AuthedQboReconciliationRouteImport } from './routes/_authed/qbo-reconciliation'
import { Route as AuthedPnlRouteImport } from './routes/_authed/pnl'
import { Route as AuthedNeedsReviewRouteImport } from './routes/_authed/needs-review'
import { Route as AuthedMrrRouteImport } from './routes/_authed/mrr'
import { Route as AuthedLoansRouteImport } from './routes/_authed/loans'
import { Route as AuthedIncomeCurvesRouteImport } from './routes/_authed/income-curves'
import { Route as AuthedFactSheetRouteImport } from './routes/_authed/fact-sheet'
import { Route as AuthedExportsRouteImport } from './routes/_authed/exports'
import { Route as AuthedExploreRouteImport } from './routes/_authed/explore'
import { Route as AuthedExpenseNaturesRouteImport } from './routes/_authed/expense-natures'
import { Route as AuthedDividendsRouteImport } from './routes/_authed/dividends'
import { Route as AuthedDiligenceRouteImport } from './routes/_authed/diligence'
import { Route as AuthedDataHealthRouteImport } from './routes/_authed/data-health'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedChurnRouteImport } from './routes/_authed/churn'
import { Route as AuthedCategorizeRouteImport } from './routes/_authed/categorize'
import { Route as AuthedCategorizationOverviewRouteImport } from './routes/_authed/categorization-overview'
import { Route as AuthedCashPositionRouteImport } from './routes/_authed/cash-position'
import { Route as AuthedCacRouteImport } from './routes/_authed/cac'
import { Route as AuthedBudgetsRouteImport } from './routes/_authed/budgets'
import { Route as AuthedBooksRouteImport } from './routes/_authed/books'
import { Route as AuthedBoardRouteImport } from './routes/_authed/board'
import { Route as AuthedStatementsIndexRouteImport } from './routes/_authed/statements/index'
import { Route as AuthedWalletSlugRouteImport } from './routes/_authed/wallet.$slug'
import { Route as AuthedTransactionsMonthRouteImport } from './routes/_authed/transactions_.$month'
import { Route as AuthedStatementsUploadRouteImport } from './routes/_authed/statements/upload'
import { Route as AuthedStakeholdersStakeholderIdRouteImport } from './routes/_authed/stakeholders_.$stakeholderId'
import { Route as AuthedSourcesReviewRouteImport } from './routes/_authed/sources_.review'
import { Route as AuthedSourcesAccountsRouteImport } from './routes/_authed/sources_.accounts'
import { Route as AuthedRulesSimilarRouteImport } from './routes/_authed/rules_.similar'
import { Route as AuthedRulesRuleIdRouteImport } from './routes/_authed/rules_.$ruleId'
import { Route as AuthedQueueJobIdRouteImport } from './routes/_authed/queue.$jobId'
import { Route as AuthedPnlMonthRouteImport } from './routes/_authed/pnl_.$month'
import { Route as AuthedDiligenceReportRouteImport } from './routes/_authed/diligence_.report'
import { Route as AuthedDataHealthBackupsRouteImport } from './routes/_authed/data-health_.backups'
import { Route as AuthedBooksCodeRouteImport } from './routes/_authed/books_.$code'
import { Route as AuthedStatementsImportsMultiUploadIdRouteImport } from './routes/_authed/statements/imports.$multiUploadId'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const OpsConsole7x2kRoute = OpsConsole7x2kRouteImport.update({
  id: '/ops-console-7x2k',
  path: '/ops-console-7x2k',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const DesignOnboardingRoute = DesignOnboardingRouteImport.update({
  id: '/design/onboarding',
  path: '/design/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTransactionsRoute = AuthedTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStripeRoute = AuthedStripeRouteImport.update({
  id: '/stripe',
  path: '/stripe',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStakeholdersMergeRoute = AuthedStakeholdersMergeRouteImport.update({
  id: '/stakeholders-merge',
  path: '/stakeholders-merge',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStakeholdersCatRoute = AuthedStakeholdersCatRouteImport.update({
  id: '/stakeholders-cat',
  path: '/stakeholders-cat',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStakeholdersRoute = AuthedStakeholdersRouteImport.update({
  id: '/stakeholders',
  path: '/stakeholders',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSourcesRoute = AuthedSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRulesRoute = AuthedRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReviewRoute = AuthedReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRevenueRoute = AuthedRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQueueRoute = AuthedQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQboReconciliationRoute = AuthedQboReconciliationRouteImport.update({
  id: '/qbo-reconciliation',
  path: '/qbo-reconciliation',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPnlRoute = AuthedPnlRouteImport.update({
  id: '/pnl',
  path: '/pnl',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNeedsReviewRoute = AuthedNeedsReviewRouteImport.update({
  id: '/needs-review',
  path: '/needs-review',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMrrRoute = AuthedMrrRouteImport.update({
  id: '/mrr',
  path: '/mrr',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLoansRoute = AuthedLoansRouteImport.update({
  id: '/loans',
  path: '/loans',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedIncomeCurvesRoute = AuthedIncomeCurvesRouteImport.update({
  id: '/income-curves',
  path: '/income-curves',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFactSheetRoute = AuthedFactSheetRouteImport.update({
  id: '/fact-sheet',
  path: '/fact-sheet',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedExportsRoute = AuthedExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedExploreRoute = AuthedExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedExpenseNaturesRoute = AuthedExpenseNaturesRouteImport.update({
  id: '/expense-natures',
  path: '/expense-natures',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDividendsRoute = AuthedDividendsRouteImport.update({
  id: '/dividends',
  path: '/dividends',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiligenceRoute = AuthedDiligenceRouteImport.update({
  id: '/diligence',
  path: '/diligence',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDataHealthRoute = AuthedDataHealthRouteImport.update({
  id: '/data-health',
  path: '/data-health',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedChurnRoute = AuthedChurnRouteImport.update({
  id: '/churn',
  path: '/churn',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCategorizeRoute = AuthedCategorizeRouteImport.update({
  id: '/categorize',
  path: '/categorize',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCategorizationOverviewRoute =
  AuthedCategorizationOverviewRouteImport.update({
    id: '/categorization-overview',
    path: '/categorization-overview',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCashPositionRoute = AuthedCashPositionRouteImport.update({
  id: '/cash-position',
  path: '/cash-position',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCacRoute = AuthedCacRouteImport.update({
  id: '/cac',
  path: '/cac',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBudgetsRoute = AuthedBudgetsRouteImport.update({
  id: '/budgets',
  path: '/budgets',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBooksRoute = AuthedBooksRouteImport.update({
  id: '/books',
  path: '/books',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBoardRoute = AuthedBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStatementsIndexRoute = AuthedStatementsIndexRouteImport.update({
  id: '/statements/',
  path: '/statements/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedWalletSlugRoute = AuthedWalletSlugRouteImport.update({
  id: '/wallet/$slug',
  path: '/wallet/$slug',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTransactionsMonthRoute = AuthedTransactionsMonthRouteImport.update({
  id: '/transactions_/$month',
  path: '/transactions/$month',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStatementsUploadRoute = AuthedStatementsUploadRouteImport.update({
  id: '/statements/upload',
  path: '/statements/upload',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStakeholdersStakeholderIdRoute =
  AuthedStakeholdersStakeholderIdRouteImport.update({
    id: '/stakeholders_/$stakeholderId',
    path: '/stakeholders/$stakeholderId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedSourcesReviewRoute = AuthedSourcesReviewRouteImport.update({
  id: '/sources_/review',
  path: '/sources/review',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSourcesAccountsRoute = AuthedSourcesAccountsRouteImport.update({
  id: '/sources_/accounts',
  path: '/sources/accounts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRulesSimilarRoute = AuthedRulesSimilarRouteImport.update({
  id: '/rules_/similar',
  path: '/rules/similar',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedRulesRuleIdRoute = AuthedRulesRuleIdRouteImport.update({
  id: '/rules_/$ruleId',
  path: '/rules/$ruleId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQueueJobIdRoute = AuthedQueueJobIdRouteImport.update({
  id: '/$jobId',
  path: '/$jobId',
  getParentRoute: () => AuthedQueueRoute,
} as any)
const AuthedPnlMonthRoute = AuthedPnlMonthRouteImport.update({
  id: '/pnl_/$month',
  path: '/pnl/$month',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDiligenceReportRoute = AuthedDiligenceReportRouteImport.update({
  id: '/diligence_/report',
  path: '/diligence/report',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDataHealthBackupsRoute = AuthedDataHealthBackupsRouteImport.update({
  id: '/data-health_/backups',
  path: '/data-health/backups',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBooksCodeRoute = AuthedBooksCodeRouteImport.update({
  id: '/books_/$code',
  path: '/books/$code',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedStatementsImportsMultiUploadIdRoute =
  AuthedStatementsImportsMultiUploadIdRouteImport.update({
    id: '/statements/imports/$multiUploadId',
    path: '/statements/imports/$multiUploadId',
    getParentRoute: () => AuthedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$slug': typeof SlugRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/ops-console-7x2k': typeof OpsConsole7x2kRoute
  '/sign-up': typeof SignUpRoute
  '/board': typeof AuthedBoardRoute
  '/books': typeof AuthedBooksRoute
  '/budgets': typeof AuthedBudgetsRoute
  '/cac': typeof AuthedCacRoute
  '/cash-position': typeof AuthedCashPositionRoute
  '/categorization-overview': typeof AuthedCategorizationOverviewRoute
  '/categorize': typeof AuthedCategorizeRoute
  '/churn': typeof AuthedChurnRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/data-health': typeof AuthedDataHealthRoute
  '/diligence': typeof AuthedDiligenceRoute
  '/dividends': typeof AuthedDividendsRoute
  '/expense-natures': typeof AuthedExpenseNaturesRoute
  '/explore': typeof AuthedExploreRoute
  '/exports': typeof AuthedExportsRoute
  '/fact-sheet': typeof AuthedFactSheetRoute
  '/income-curves': typeof AuthedIncomeCurvesRoute
  '/loans': typeof AuthedLoansRoute
  '/mrr': typeof AuthedMrrRoute
  '/needs-review': typeof AuthedNeedsReviewRoute
  '/pnl': typeof AuthedPnlRoute
  '/qbo-reconciliation': typeof AuthedQboReconciliationRoute
  '/queue': typeof AuthedQueueRouteWithChildren
  '/revenue': typeof AuthedRevenueRoute
  '/review': typeof AuthedReviewRoute
  '/rules': typeof AuthedRulesRoute
  '/sources': typeof AuthedSourcesRoute
  '/stakeholders': typeof AuthedStakeholdersRoute
  '/stakeholders-cat': typeof AuthedStakeholdersCatRoute
  '/stakeholders-merge': typeof AuthedStakeholdersMergeRoute
  '/stripe': typeof AuthedStripeRoute
  '/transactions': typeof AuthedTransactionsRoute
  '/design/onboarding': typeof DesignOnboardingRoute
  '/': typeof AuthedIndexRoute
  '/books/$code': typeof AuthedBooksCodeRoute
  '/data-health/backups': typeof AuthedDataHealthBackupsRoute
  '/diligence/report': typeof AuthedDiligenceReportRoute
  '/pnl/$month': typeof AuthedPnlMonthRoute
  '/queue/$jobId': typeof AuthedQueueJobIdRoute
  '/rules/$ruleId': typeof AuthedRulesRuleIdRoute
  '/rules/similar': typeof AuthedRulesSimilarRoute
  '/sources/accounts': typeof AuthedSourcesAccountsRoute
  '/sources/review': typeof AuthedSourcesReviewRoute
  '/stakeholders/$stakeholderId': typeof AuthedStakeholdersStakeholderIdRoute
  '/statements/upload': typeof AuthedStatementsUploadRoute
  '/transactions/$month': typeof AuthedTransactionsMonthRoute
  '/wallet/$slug': typeof AuthedWalletSlugRoute
  '/statements': typeof AuthedStatementsIndexRoute
  '/statements/imports/$multiUploadId': typeof AuthedStatementsImportsMultiUploadIdRoute
}
export interface FileRoutesByTo {
  '/$slug': typeof SlugRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/ops-console-7x2k': typeof OpsConsole7x2kRoute
  '/sign-up': typeof SignUpRoute
  '/board': typeof AuthedBoardRoute
  '/books': typeof AuthedBooksRoute
  '/budgets': typeof AuthedBudgetsRoute
  '/cac': typeof AuthedCacRoute
  '/cash-position': typeof AuthedCashPositionRoute
  '/categorization-overview': typeof AuthedCategorizationOverviewRoute
  '/categorize': typeof AuthedCategorizeRoute
  '/churn': typeof AuthedChurnRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/data-health': typeof AuthedDataHealthRoute
  '/diligence': typeof AuthedDiligenceRoute
  '/dividends': typeof AuthedDividendsRoute
  '/expense-natures': typeof AuthedExpenseNaturesRoute
  '/explore': typeof AuthedExploreRoute
  '/exports': typeof AuthedExportsRoute
  '/fact-sheet': typeof AuthedFactSheetRoute
  '/income-curves': typeof AuthedIncomeCurvesRoute
  '/loans': typeof AuthedLoansRoute
  '/mrr': typeof AuthedMrrRoute
  '/needs-review': typeof AuthedNeedsReviewRoute
  '/pnl': typeof AuthedPnlRoute
  '/qbo-reconciliation': typeof AuthedQboReconciliationRoute
  '/queue': typeof AuthedQueueRouteWithChildren
  '/revenue': typeof AuthedRevenueRoute
  '/review': typeof AuthedReviewRoute
  '/rules': typeof AuthedRulesRoute
  '/sources': typeof AuthedSourcesRoute
  '/stakeholders': typeof AuthedStakeholdersRoute
  '/stakeholders-cat': typeof AuthedStakeholdersCatRoute
  '/stakeholders-merge': typeof AuthedStakeholdersMergeRoute
  '/stripe': typeof AuthedStripeRoute
  '/transactions': typeof AuthedTransactionsRoute
  '/design/onboarding': typeof DesignOnboardingRoute
  '/': typeof AuthedIndexRoute
  '/books/$code': typeof AuthedBooksCodeRoute
  '/data-health/backups': typeof AuthedDataHealthBackupsRoute
  '/diligence/report': typeof AuthedDiligenceReportRoute
  '/pnl/$month': typeof AuthedPnlMonthRoute
  '/queue/$jobId': typeof AuthedQueueJobIdRoute
  '/rules/$ruleId': typeof AuthedRulesRuleIdRoute
  '/rules/similar': typeof AuthedRulesSimilarRoute
  '/sources/accounts': typeof AuthedSourcesAccountsRoute
  '/sources/review': typeof AuthedSourcesReviewRoute
  '/stakeholders/$stakeholderId': typeof AuthedStakeholdersStakeholderIdRoute
  '/statements/upload': typeof AuthedStatementsUploadRoute
  '/transactions/$month': typeof AuthedTransactionsMonthRoute
  '/wallet/$slug': typeof AuthedWalletSlugRoute
  '/statements': typeof AuthedStatementsIndexRoute
  '/statements/imports/$multiUploadId': typeof AuthedStatementsImportsMultiUploadIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$slug': typeof SlugRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/ops-console-7x2k': typeof OpsConsole7x2kRoute
  '/sign-up': typeof SignUpRoute
  '/_authed/board': typeof AuthedBoardRoute
  '/_authed/books': typeof AuthedBooksRoute
  '/_authed/budgets': typeof AuthedBudgetsRoute
  '/_authed/cac': typeof AuthedCacRoute
  '/_authed/cash-position': typeof AuthedCashPositionRoute
  '/_authed/categorization-overview': typeof AuthedCategorizationOverviewRoute
  '/_authed/categorize': typeof AuthedCategorizeRoute
  '/_authed/churn': typeof AuthedChurnRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/data-health': typeof AuthedDataHealthRoute
  '/_authed/diligence': typeof AuthedDiligenceRoute
  '/_authed/dividends': typeof AuthedDividendsRoute
  '/_authed/expense-natures': typeof AuthedExpenseNaturesRoute
  '/_authed/explore': typeof AuthedExploreRoute
  '/_authed/exports': typeof AuthedExportsRoute
  '/_authed/fact-sheet': typeof AuthedFactSheetRoute
  '/_authed/income-curves': typeof AuthedIncomeCurvesRoute
  '/_authed/loans': typeof AuthedLoansRoute
  '/_authed/mrr': typeof AuthedMrrRoute
  '/_authed/needs-review': typeof AuthedNeedsReviewRoute
  '/_authed/pnl': typeof AuthedPnlRoute
  '/_authed/qbo-reconciliation': typeof AuthedQboReconciliationRoute
  '/_authed/queue': typeof AuthedQueueRouteWithChildren
  '/_authed/revenue': typeof AuthedRevenueRoute
  '/_authed/review': typeof AuthedReviewRoute
  '/_authed/rules': typeof AuthedRulesRoute
  '/_authed/sources': typeof AuthedSourcesRoute
  '/_authed/stakeholders': typeof AuthedStakeholdersRoute
  '/_authed/stakeholders-cat': typeof AuthedStakeholdersCatRoute
  '/_authed/stakeholders-merge': typeof AuthedStakeholdersMergeRoute
  '/_authed/stripe': typeof AuthedStripeRoute
  '/_authed/transactions': typeof AuthedTransactionsRoute
  '/design/onboarding': typeof DesignOnboardingRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/books_/$code': typeof AuthedBooksCodeRoute
  '/_authed/data-health_/backups': typeof AuthedDataHealthBackupsRoute
  '/_authed/diligence_/report': typeof AuthedDiligenceReportRoute
  '/_authed/pnl_/$month': typeof AuthedPnlMonthRoute
  '/_authed/queue/$jobId': typeof AuthedQueueJobIdRoute
  '/_authed/rules_/$ruleId': typeof AuthedRulesRuleIdRoute
  '/_authed/rules_/similar': typeof AuthedRulesSimilarRoute
  '/_authed/sources_/accounts': typeof AuthedSourcesAccountsRoute
  '/_authed/sources_/review': typeof AuthedSourcesReviewRoute
  '/_authed/stakeholders_/$stakeholderId': typeof AuthedStakeholdersStakeholderIdRoute
  '/_authed/statements/upload': typeof AuthedStatementsUploadRoute
  '/_authed/transactions_/$month': typeof AuthedTransactionsMonthRoute
  '/_authed/wallet/$slug': typeof AuthedWalletSlugRoute
  '/_authed/statements/': typeof AuthedStatementsIndexRoute
  '/_authed/statements/imports/$multiUploadId': typeof AuthedStatementsImportsMultiUploadIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$slug'
    | '/login'
    | '/onboarding'
    | '/ops-console-7x2k'
    | '/sign-up'
    | '/board'
    | '/books'
    | '/budgets'
    | '/cac'
    | '/cash-position'
    | '/categorization-overview'
    | '/categorize'
    | '/churn'
    | '/dashboard'
    | '/data-health'
    | '/diligence'
    | '/dividends'
    | '/expense-natures'
    | '/explore'
    | '/exports'
    | '/fact-sheet'
    | '/income-curves'
    | '/loans'
    | '/mrr'
    | '/needs-review'
    | '/pnl'
    | '/qbo-reconciliation'
    | '/queue'
    | '/revenue'
    | '/review'
    | '/rules'
    | '/sources'
    | '/stakeholders'
    | '/stakeholders-cat'
    | '/stakeholders-merge'
    | '/stripe'
    | '/transactions'
    | '/design/onboarding'
    | '/'
    | '/books/$code'
    | '/data-health/backups'
    | '/diligence/report'
    | '/pnl/$month'
    | '/queue/$jobId'
    | '/rules/$ruleId'
    | '/rules/similar'
    | '/sources/accounts'
    | '/sources/review'
    | '/stakeholders/$stakeholderId'
    | '/statements/upload'
    | '/transactions/$month'
    | '/wallet/$slug'
    | '/statements'
    | '/statements/imports/$multiUploadId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$slug'
    | '/login'
    | '/onboarding'
    | '/ops-console-7x2k'
    | '/sign-up'
    | '/board'
    | '/books'
    | '/budgets'
    | '/cac'
    | '/cash-position'
    | '/categorization-overview'
    | '/categorize'
    | '/churn'
    | '/dashboard'
    | '/data-health'
    | '/diligence'
    | '/dividends'
    | '/expense-natures'
    | '/explore'
    | '/exports'
    | '/fact-sheet'
    | '/income-curves'
    | '/loans'
    | '/mrr'
    | '/needs-review'
    | '/pnl'
    | '/qbo-reconciliation'
    | '/queue'
    | '/revenue'
    | '/review'
    | '/rules'
    | '/sources'
    | '/stakeholders'
    | '/stakeholders-cat'
    | '/stakeholders-merge'
    | '/stripe'
    | '/transactions'
    | '/design/onboarding'
    | '/'
    | '/books/$code'
    | '/data-health/backups'
    | '/diligence/report'
    | '/pnl/$month'
    | '/queue/$jobId'
    | '/rules/$ruleId'
    | '/rules/similar'
    | '/sources/accounts'
    | '/sources/review'
    | '/stakeholders/$stakeholderId'
    | '/statements/upload'
    | '/transactions/$month'
    | '/wallet/$slug'
    | '/statements'
    | '/statements/imports/$multiUploadId'
  id:
    | '__root__'
    | '/$slug'
    | '/_authed'
    | '/login'
    | '/onboarding'
    | '/ops-console-7x2k'
    | '/sign-up'
    | '/_authed/board'
    | '/_authed/books'
    | '/_authed/budgets'
    | '/_authed/cac'
    | '/_authed/cash-position'
    | '/_authed/categorization-overview'
    | '/_authed/categorize'
    | '/_authed/churn'
    | '/_authed/dashboard'
    | '/_authed/data-health'
    | '/_authed/diligence'
    | '/_authed/dividends'
    | '/_authed/expense-natures'
    | '/_authed/explore'
    | '/_authed/exports'
    | '/_authed/fact-sheet'
    | '/_authed/income-curves'
    | '/_authed/loans'
    | '/_authed/mrr'
    | '/_authed/needs-review'
    | '/_authed/pnl'
    | '/_authed/qbo-reconciliation'
    | '/_authed/queue'
    | '/_authed/revenue'
    | '/_authed/review'
    | '/_authed/rules'
    | '/_authed/sources'
    | '/_authed/stakeholders'
    | '/_authed/stakeholders-cat'
    | '/_authed/stakeholders-merge'
    | '/_authed/stripe'
    | '/_authed/transactions'
    | '/design/onboarding'
    | '/_authed/'
    | '/_authed/books_/$code'
    | '/_authed/data-health_/backups'
    | '/_authed/diligence_/report'
    | '/_authed/pnl_/$month'
    | '/_authed/queue/$jobId'
    | '/_authed/rules_/$ruleId'
    | '/_authed/rules_/similar'
    | '/_authed/sources_/accounts'
    | '/_authed/sources_/review'
    | '/_authed/stakeholders_/$stakeholderId'
    | '/_authed/statements/upload'
    | '/_authed/transactions_/$month'
    | '/_authed/wallet/$slug'
    | '/_authed/statements/'
    | '/_authed/statements/imports/$multiUploadId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SlugRoute: typeof SlugRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  OpsConsole7x2kRoute: typeof OpsConsole7x2kRoute
  SignUpRoute: typeof SignUpRoute
  DesignOnboardingRoute: typeof DesignOnboardingRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ops-console-7x2k': {
      id: '/ops-console-7x2k'
      path: '/ops-console-7x2k'
      fullPath: '/ops-console-7x2k'
      preLoaderRoute: typeof OpsConsole7x2kRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/design/onboarding': {
      id: '/design/onboarding'
      path: '/design/onboarding'
      fullPath: '/design/onboarding'
      preLoaderRoute: typeof DesignOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/transactions': {
      id: '/_authed/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AuthedTransactionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stripe': {
      id: '/_authed/stripe'
      path: '/stripe'
      fullPath: '/stripe'
      preLoaderRoute: typeof AuthedStripeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stakeholders-merge': {
      id: '/_authed/stakeholders-merge'
      path: '/stakeholders-merge'
      fullPath: '/stakeholders-merge'
      preLoaderRoute: typeof AuthedStakeholdersMergeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stakeholders-cat': {
      id: '/_authed/stakeholders-cat'
      path: '/stakeholders-cat'
      fullPath: '/stakeholders-cat'
      preLoaderRoute: typeof AuthedStakeholdersCatRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stakeholders': {
      id: '/_authed/stakeholders'
      path: '/stakeholders'
      fullPath: '/stakeholders'
      preLoaderRoute: typeof AuthedStakeholdersRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sources': {
      id: '/_authed/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof AuthedSourcesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rules': {
      id: '/_authed/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof AuthedRulesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/review': {
      id: '/_authed/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AuthedReviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/revenue': {
      id: '/_authed/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof AuthedRevenueRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/queue': {
      id: '/_authed/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof AuthedQueueRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/qbo-reconciliation': {
      id: '/_authed/qbo-reconciliation'
      path: '/qbo-reconciliation'
      fullPath: '/qbo-reconciliation'
      preLoaderRoute: typeof AuthedQboReconciliationRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pnl': {
      id: '/_authed/pnl'
      path: '/pnl'
      fullPath: '/pnl'
      preLoaderRoute: typeof AuthedPnlRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/needs-review': {
      id: '/_authed/needs-review'
      path: '/needs-review'
      fullPath: '/needs-review'
      preLoaderRoute: typeof AuthedNeedsReviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/mrr': {
      id: '/_authed/mrr'
      path: '/mrr'
      fullPath: '/mrr'
      preLoaderRoute: typeof AuthedMrrRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/loans': {
      id: '/_authed/loans'
      path: '/loans'
      fullPath: '/loans'
      preLoaderRoute: typeof AuthedLoansRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/income-curves': {
      id: '/_authed/income-curves'
      path: '/income-curves'
      fullPath: '/income-curves'
      preLoaderRoute: typeof AuthedIncomeCurvesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/fact-sheet': {
      id: '/_authed/fact-sheet'
      path: '/fact-sheet'
      fullPath: '/fact-sheet'
      preLoaderRoute: typeof AuthedFactSheetRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/exports': {
      id: '/_authed/exports'
      path: '/exports'
      fullPath: '/exports'
      preLoaderRoute: typeof AuthedExportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/explore': {
      id: '/_authed/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AuthedExploreRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/expense-natures': {
      id: '/_authed/expense-natures'
      path: '/expense-natures'
      fullPath: '/expense-natures'
      preLoaderRoute: typeof AuthedExpenseNaturesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dividends': {
      id: '/_authed/dividends'
      path: '/dividends'
      fullPath: '/dividends'
      preLoaderRoute: typeof AuthedDividendsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/diligence': {
      id: '/_authed/diligence'
      path: '/diligence'
      fullPath: '/diligence'
      preLoaderRoute: typeof AuthedDiligenceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/data-health': {
      id: '/_authed/data-health'
      path: '/data-health'
      fullPath: '/data-health'
      preLoaderRoute: typeof AuthedDataHealthRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/churn': {
      id: '/_authed/churn'
      path: '/churn'
      fullPath: '/churn'
      preLoaderRoute: typeof AuthedChurnRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/categorize': {
      id: '/_authed/categorize'
      path: '/categorize'
      fullPath: '/categorize'
      preLoaderRoute: typeof AuthedCategorizeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/categorization-overview': {
      id: '/_authed/categorization-overview'
      path: '/categorization-overview'
      fullPath: '/categorization-overview'
      preLoaderRoute: typeof AuthedCategorizationOverviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cash-position': {
      id: '/_authed/cash-position'
      path: '/cash-position'
      fullPath: '/cash-position'
      preLoaderRoute: typeof AuthedCashPositionRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/cac': {
      id: '/_authed/cac'
      path: '/cac'
      fullPath: '/cac'
      preLoaderRoute: typeof AuthedCacRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/budgets': {
      id: '/_authed/budgets'
      path: '/budgets'
      fullPath: '/budgets'
      preLoaderRoute: typeof AuthedBudgetsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/books': {
      id: '/_authed/books'
      path: '/books'
      fullPath: '/books'
      preLoaderRoute: typeof AuthedBooksRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/board': {
      id: '/_authed/board'
      path: '/board'
      fullPath: '/board'
      preLoaderRoute: typeof AuthedBoardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/statements/': {
      id: '/_authed/statements/'
      path: '/statements'
      fullPath: '/statements'
      preLoaderRoute: typeof AuthedStatementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/wallet/$slug': {
      id: '/_authed/wallet/$slug'
      path: '/wallet/$slug'
      fullPath: '/wallet/$slug'
      preLoaderRoute: typeof AuthedWalletSlugRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/transactions_/$month': {
      id: '/_authed/transactions_/$month'
      path: '/transactions/$month'
      fullPath: '/transactions/$month'
      preLoaderRoute: typeof AuthedTransactionsMonthRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/statements/upload': {
      id: '/_authed/statements/upload'
      path: '/statements/upload'
      fullPath: '/statements/upload'
      preLoaderRoute: typeof AuthedStatementsUploadRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/stakeholders_/$stakeholderId': {
      id: '/_authed/stakeholders_/$stakeholderId'
      path: '/stakeholders/$stakeholderId'
      fullPath: '/stakeholders/$stakeholderId'
      preLoaderRoute: typeof AuthedStakeholdersStakeholderIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sources_/review': {
      id: '/_authed/sources_/review'
      path: '/sources/review'
      fullPath: '/sources/review'
      preLoaderRoute: typeof AuthedSourcesReviewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/sources_/accounts': {
      id: '/_authed/sources_/accounts'
      path: '/sources/accounts'
      fullPath: '/sources/accounts'
      preLoaderRoute: typeof AuthedSourcesAccountsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rules_/similar': {
      id: '/_authed/rules_/similar'
      path: '/rules/similar'
      fullPath: '/rules/similar'
      preLoaderRoute: typeof AuthedRulesSimilarRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/rules_/$ruleId': {
      id: '/_authed/rules_/$ruleId'
      path: '/rules/$ruleId'
      fullPath: '/rules/$ruleId'
      preLoaderRoute: typeof AuthedRulesRuleIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/queue/$jobId': {
      id: '/_authed/queue/$jobId'
      path: '/$jobId'
      fullPath: '/queue/$jobId'
      preLoaderRoute: typeof AuthedQueueJobIdRouteImport
      parentRoute: typeof AuthedQueueRoute
    }
    '/_authed/pnl_/$month': {
      id: '/_authed/pnl_/$month'
      path: '/pnl/$month'
      fullPath: '/pnl/$month'
      preLoaderRoute: typeof AuthedPnlMonthRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/diligence_/report': {
      id: '/_authed/diligence_/report'
      path: '/diligence/report'
      fullPath: '/diligence/report'
      preLoaderRoute: typeof AuthedDiligenceReportRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/data-health_/backups': {
      id: '/_authed/data-health_/backups'
      path: '/data-health/backups'
      fullPath: '/data-health/backups'
      preLoaderRoute: typeof AuthedDataHealthBackupsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/books_/$code': {
      id: '/_authed/books_/$code'
      path: '/books/$code'
      fullPath: '/books/$code'
      preLoaderRoute: typeof AuthedBooksCodeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/statements/imports/$multiUploadId': {
      id: '/_authed/statements/imports/$multiUploadId'
      path: '/statements/imports/$multiUploadId'
      fullPath: '/statements/imports/$multiUploadId'
      preLoaderRoute: typeof AuthedStatementsImportsMultiUploadIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedQueueRouteChildren {
  AuthedQueueJobIdRoute: typeof AuthedQueueJobIdRoute
}

const AuthedQueueRouteChildren: AuthedQueueRouteChildren = {
  AuthedQueueJobIdRoute: AuthedQueueJobIdRoute,
}

const AuthedQueueRouteWithChildren = AuthedQueueRoute._addFileChildren(
  AuthedQueueRouteChildren,
)

interface AuthedRouteChildren {
  AuthedBoardRoute: typeof AuthedBoardRoute
  AuthedBooksRoute: typeof AuthedBooksRoute
  AuthedBudgetsRoute: typeof AuthedBudgetsRoute
  AuthedCacRoute: typeof AuthedCacRoute
  AuthedCashPositionRoute: typeof AuthedCashPositionRoute
  AuthedCategorizationOverviewRoute: typeof AuthedCategorizationOverviewRoute
  AuthedCategorizeRoute: typeof AuthedCategorizeRoute
  AuthedChurnRoute: typeof AuthedChurnRoute
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDataHealthRoute: typeof AuthedDataHealthRoute
  AuthedDiligenceRoute: typeof AuthedDiligenceRoute
  AuthedDividendsRoute: typeof AuthedDividendsRoute
  AuthedExpenseNaturesRoute: typeof AuthedExpenseNaturesRoute
  AuthedExploreRoute: typeof AuthedExploreRoute
  AuthedExportsRoute: typeof AuthedExportsRoute
  AuthedFactSheetRoute: typeof AuthedFactSheetRoute
  AuthedIncomeCurvesRoute: typeof AuthedIncomeCurvesRoute
  AuthedLoansRoute: typeof AuthedLoansRoute
  AuthedMrrRoute: typeof AuthedMrrRoute
  AuthedNeedsReviewRoute: typeof AuthedNeedsReviewRoute
  AuthedPnlRoute: typeof AuthedPnlRoute
  AuthedQboReconciliationRoute: typeof AuthedQboReconciliationRoute
  AuthedQueueRoute: typeof AuthedQueueRouteWithChildren
  AuthedRevenueRoute: typeof AuthedRevenueRoute
  AuthedReviewRoute: typeof AuthedReviewRoute
  AuthedRulesRoute: typeof AuthedRulesRoute
  AuthedSourcesRoute: typeof AuthedSourcesRoute
  AuthedStakeholdersRoute: typeof AuthedStakeholdersRoute
  AuthedStakeholdersCatRoute: typeof AuthedStakeholdersCatRoute
  AuthedStakeholdersMergeRoute: typeof AuthedStakeholdersMergeRoute
  AuthedStripeRoute: typeof AuthedStripeRoute
  AuthedTransactionsRoute: typeof AuthedTransactionsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedBooksCodeRoute: typeof AuthedBooksCodeRoute
  AuthedDataHealthBackupsRoute: typeof AuthedDataHealthBackupsRoute
  AuthedDiligenceReportRoute: typeof AuthedDiligenceReportRoute
  AuthedPnlMonthRoute: typeof AuthedPnlMonthRoute
  AuthedRulesRuleIdRoute: typeof AuthedRulesRuleIdRoute
  AuthedRulesSimilarRoute: typeof AuthedRulesSimilarRoute
  AuthedSourcesAccountsRoute: typeof AuthedSourcesAccountsRoute
  AuthedSourcesReviewRoute: typeof AuthedSourcesReviewRoute
  AuthedStakeholdersStakeholderIdRoute: typeof AuthedStakeholdersStakeholderIdRoute
  AuthedStatementsUploadRoute: typeof AuthedStatementsUploadRoute
  AuthedTransactionsMonthRoute: typeof AuthedTransactionsMonthRoute
  AuthedWalletSlugRoute: typeof AuthedWalletSlugRoute
  AuthedStatementsIndexRoute: typeof AuthedStatementsIndexRoute
  AuthedStatementsImportsMultiUploadIdRoute: typeof AuthedStatementsImportsMultiUploadIdRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedBoardRoute: AuthedBoardRoute,
  AuthedBooksRoute: AuthedBooksRoute,
  AuthedBudgetsRoute: AuthedBudgetsRoute,
  AuthedCacRoute: AuthedCacRoute,
  AuthedCashPositionRoute: AuthedCashPositionRoute,
  AuthedCategorizationOverviewRoute: AuthedCategorizationOverviewRoute,
  AuthedCategorizeRoute: AuthedCategorizeRoute,
  AuthedChurnRoute: AuthedChurnRoute,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDataHealthRoute: AuthedDataHealthRoute,
  AuthedDiligenceRoute: AuthedDiligenceRoute,
  AuthedDividendsRoute: AuthedDividendsRoute,
  AuthedExpenseNaturesRoute: AuthedExpenseNaturesRoute,
  AuthedExploreRoute: AuthedExploreRoute,
  AuthedExportsRoute: AuthedExportsRoute,
  AuthedFactSheetRoute: AuthedFactSheetRoute,
  AuthedIncomeCurvesRoute: AuthedIncomeCurvesRoute,
  AuthedLoansRoute: AuthedLoansRoute,
  AuthedMrrRoute: AuthedMrrRoute,
  AuthedNeedsReviewRoute: AuthedNeedsReviewRoute,
  AuthedPnlRoute: AuthedPnlRoute,
  AuthedQboReconciliationRoute: AuthedQboReconciliationRoute,
  AuthedQueueRoute: AuthedQueueRouteWithChildren,
  AuthedRevenueRoute: AuthedRevenueRoute,
  AuthedReviewRoute: AuthedReviewRoute,
  AuthedRulesRoute: AuthedRulesRoute,
  AuthedSourcesRoute: AuthedSourcesRoute,
  AuthedStakeholdersRoute: AuthedStakeholdersRoute,
  AuthedStakeholdersCatRoute: AuthedStakeholdersCatRoute,
  AuthedStakeholdersMergeRoute: AuthedStakeholdersMergeRoute,
  AuthedStripeRoute: AuthedStripeRoute,
  AuthedTransactionsRoute: AuthedTransactionsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedBooksCodeRoute: AuthedBooksCodeRoute,
  AuthedDataHealthBackupsRoute: AuthedDataHealthBackupsRoute,
  AuthedDiligenceReportRoute: AuthedDiligenceReportRoute,
  AuthedPnlMonthRoute: AuthedPnlMonthRoute,
  AuthedRulesRuleIdRoute: AuthedRulesRuleIdRoute,
  AuthedRulesSimilarRoute: AuthedRulesSimilarRoute,
  AuthedSourcesAccountsRoute: AuthedSourcesAccountsRoute,
  AuthedSourcesReviewRoute: AuthedSourcesReviewRoute,
  AuthedStakeholdersStakeholderIdRoute: AuthedStakeholdersStakeholderIdRoute,
  AuthedStatementsUploadRoute: AuthedStatementsUploadRoute,
  AuthedTransactionsMonthRoute: AuthedTransactionsMonthRoute,
  AuthedWalletSlugRoute: AuthedWalletSlugRoute,
  AuthedStatementsIndexRoute: AuthedStatementsIndexRoute,
  AuthedStatementsImportsMultiUploadIdRoute:
    AuthedStatementsImportsMultiUploadIdRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SlugRoute: SlugRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  OpsConsole7x2kRoute: OpsConsole7x2kRoute,
  SignUpRoute: SignUpRoute,
  DesignOnboardingRoute: DesignOnboardingRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
